export enum FlowLevel {
  Story, // 0
  Knot, // 1
  Stitch, // 2
  // not actually a FlowBase, but used for diverts
  WeavePoint, // 3
}
